import React, { useState } from 'react';
import { BrandLogo } from '@go-client/components/UIkit/Brand/BrandLogo/BrandLogo';
import Page from '../Page';
import Config from '@go-client/lib/config';
import { RouteComponentProps } from 'react-router';
import KafkaLogger from './KafkaLogger/KafkaLogger';
import KafkaOutgoingMessagesLog from './KafkaOutgoingMessagesLog/KafkaOutgoingMessagesLog';
import { Button, InlineIcon } from '@spark-labs/avocado-ui';
import './KafkaControl.scss';
import { MenuBar } from '@go-client/components';
type TabType = 'logger' | 'outgoing-messages';

const KafkaControl: React.FC<RouteComponentProps> = props => {
  const [tab, setTab] = useState<TabType>('logger');
  const activeLinkClass = 'bg-blue-darker';

  return (
    <Page className="KafkaControl absolute flex items-stretch w-full h-full">
      <MenuBar {...props} />
      <div className="SideMenu bg-blue-darkest flex flex-col">
        <BrandLogo logo={Config.BRAND_LOGO_URL} />
        <div className={`mb-4 mx-2 rounded mt-8 ${tab === 'logger' ? activeLinkClass : ''}`}>
          <Button
            className="w-full py-3 text-left pl-2 text-white font-semibold"
            onClick={() => {
              setTab('logger');
            }}
          >
            <span
              style={{ transform: 'rotate(-90deg)', fontSize: 10 }}
              className="inline-flex text-xs"
            >
              <InlineIcon name="chevron-down" className="menu-icon" />
            </span>
            <span className="ml-2 text-xs">Incoming Messages</span>
          </Button>
        </div>
        <div className={`mb-4 mx-2 rounded ${tab === 'outgoing-messages' ? activeLinkClass : ''}`}>
          <Button
            className="w-full py-3 text-left pl-2 font-semibold text-white"
            onClick={() => {
              setTab('outgoing-messages');
            }}
          >
            <span style={{ transform: 'rotate(90deg)' }} className="inline-flex">
              <InlineIcon name="chevron-down" className="menu-icon" />
            </span>
            <span className="ml-2 text-xs">Outgoing Messages</span>
          </Button>
        </div>
      </div>
      {tab === 'logger' ? <KafkaLogger {...props} /> : null}
      {tab === 'outgoing-messages' ? <KafkaOutgoingMessagesLog {...props} /> : null}
      <div></div>
    </Page>
  );
};

export default KafkaControl;
